/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Recruiter app display language. Values are the i18next language codes the UI loads.
 */
export type UiLanguage = (typeof UiLanguage)[keyof typeof UiLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UiLanguage = {
  en: 'en',
  fr: 'fr',
  es: 'es',
  'es-ES': 'es-ES',
  de: 'de',
  nl: 'nl',
  'nl-BE': 'nl-BE',
} as const;
